import { useQuery } from '@tanstack/react-query';
import React, { useEffect, useState } from 'react';
import logo from '../../../assets/msw-logo.png';
import axios from '../../../api/axios';

const NDOTApproval = () => {
    const APPROVED_STATUS = 1;

    const search = window.location.search;
    const param = new URLSearchParams(search);
    const token = param.get('token');

    const [message, setMessage] = useState(null);

    const { data: approvedNDOT, isLoading, error } = useQuery({
        queryKey: ['userNDOTRequestApproval'],
        queryFn: async () => {
            const res = await axios.patch('ndot', { status: APPROVED_STATUS }, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            return res.data.response;
        },
        enabled: !!token,
        staleTime: Infinity,
        retry: false
    });

    useEffect(() => {
        if (error) {
            setMessage(error.response?.data.response || 'Something went wrong while approving NDOT request!');
        } else if (approvedNDOT) {
            setMessage(approvedNDOT);
        }
    }, [approvedNDOT, error]);

    return (
        <div className='approval-disapproval approved'>
            <div className='icon'>
                <i className={`fa ${isLoading ? 'fa-spinner fa-spin' : (error || !token ? 'fa-exclamation-triangle' : 'fa-check-circle')}`}></i>
            </div>
            <p className='message'>
                {isLoading ? 'Loading...' : (!token ? 'Invalid access: missing token' : message)}
            </p>
            <div className='ad-footer'>
                <div className='logo'>
                    <img src={logo} alt='Logo' />
                </div>
                <p>&copy; Megasportsworld 2025</p>
            </div>
        </div>
    )
}

export default NDOTApproval;